import { globalVariables } from "helper/globalVariables";

export const dogsOptions = [
  "Dog1",
  "Dog2",
  "Dog3",
  "Dog4",
  "Dog5",
  "Dog6",
  "Dog7",
  "Dog8",
  "Dog9",
  "Dog10",
  "Dog11",
  "Dog12",
  "Dog13",
  "Dog14",
  "Dog15",
];
export const divisionOptions = ["Standard", "Pro", "FEO"];
export const elementsOptions = ["Birch SIT", "Anise SIT", "Clove SIT"];

export const dropdowns = [
  // {
  //   name: "dog",
  //   placeHolder: globalVariables.dogDropdown,
  //   errorMsg: globalVariables.dogDropdownRequired,
  //   options: dogsOptions,
  // },
  {
    name: "division",
    placeHolder: globalVariables.division,
    errorMsg: globalVariables.divisionRequired,
    options: divisionOptions,
    disabled: false,
  },
];
